import {
  ActionType,
  getActionTypeFromInstance,
  NgxsNextPluginFn,
} from '@ngxs/store';
import { AuthLogoutAction } from '../auth/auth.actions';
import { SsoClearStateAction } from '../sso/sso.actions';

export function logoutPlugin(
  state: any,
  action: ActionType,
  next: NgxsNextPluginFn
) {
  // Use the get action type helper to determine the type
  if (
    getActionTypeFromInstance(action) === AuthLogoutAction.type ||
    getActionTypeFromInstance(action) === SsoClearStateAction.type
  ) {
    // if we are a logout type, lets erase all the state
    console.log('🧹 Logout plugin: Limpiando todo el estado de la aplicación');
    state = {};
  }

  // return the next function with the empty state
  return next(state, action);
}
